import type { IReturn, ResponseBase } from 'tm3-core/api.dtos';

export interface Constructable<T> {
  new (...args: any[]): T;
  name: string;
}

export interface ApiDtoReq<T = any, R = any> {
  new (init?: Partial<T>): T & IReturn<R>;

  name: string;
}
export interface ApiDtoReqRBase<T = any, R = any> {
  new (init?: Partial<T>): T & IReturn<ResponseBase<R>>;

  name: string;
}

export type Nullable<T> = {
  [P in keyof T]?: T[P] | null;
};

export type NotNullable<T extends object> = {
  [P in keyof T]: Exclude<T[P], null>;
};

export type PartiallyNotNullable<T, K extends keyof T> = {
  [P in keyof T]: P extends K ? NonNullable<T[P]> : T[P];
};

export const EnumEntryFilter = <T extends any>(
  entry: [string, T | string]
): entry is [string, T] => {
  const [key, value] = entry;
  return !String.isString(value);
};

export const AsNullable = <T extends object>(x: T): Nullable<T> => {
  return x as Nullable<T>;
};

export const AsPartial = <T extends object>(x: T): Partial<T> => {
  return x as Partial<T>;
};

export type KeyMap<T> = {
  [P in keyof T]: boolean;
};

export type DirtiedMap<T> = Partial<KeyMap<T>>;

export type FcProps<T> = T extends React.FC<infer X> ? X : never;
